import React, { useState, useEffect } from 'react';
import { Typography } from 'lib/components';
import { Checkbox } from 'lib/components/FormFields';
import { AllCheckedStatus } from 'types';
import classes from './index.module.scss';

interface Props {
	item: any;
	allCheckedStatus: AllCheckedStatus;
	checkAction: (id: number, isChecked: boolean) => void;
}

const ItemRow = ({ item, allCheckedStatus, checkAction }: Props) => {
	const [checked, setChecked] = useState(false);

	useEffect(() => {
		if (allCheckedStatus === 'some') return;
		if (allCheckedStatus === 'all') setChecked(true);
		if (allCheckedStatus === 'none') setChecked(false);
	}, [allCheckedStatus]);

	const handleChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
		setChecked(e.target.checked);
		checkAction(item.id, e.target.checked);
	};

	return (
		<div className={classes['table-row']}>
			<Checkbox
				checked={checked}
				onChange={handleChecked}
				style={{
					margin: '0 2rem',
				}}
			/>
			<Typography variant={'h6'} className={classes['col']}>
				{item.id}
			</Typography>
			<Typography variant={'h6'} className={classes['col']}>
				{item.name}
			</Typography>
		</div>
	);
};

export default ItemRow;
